import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "@/lib/cn";

export function Card({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return (
    <section className={cn("rounded-card border border-line bg-surface shadow-card", className)} {...props} />
  );
}

export function CardHeader({ title, actions }: { title: ReactNode; actions?: ReactNode }) {
  return (
    <header className="flex min-h-14 items-center justify-between gap-3 border-b border-line px-5">
      <h2 className="text-[0.95rem] font-semibold">{title}</h2>
      {actions}
    </header>
  );
}

export function CardBody({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("p-5", className)} {...props} />;
}
